package navigation.home.travelagents.addedittravelagent

import addedittravelagent.AddEditTravelAgentEvent
import addedittravelagent.AddEditTravelAgentState
import addedittravelagent.AddEditTravelAgentViewModel
import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository
import com.essntl.toastmanager.ToastManager

class AddEditTravelAgentScreenModel(
    travelAgentRepository: TravelAgentRepository,
    fileRepository: FileRepository,
    proposalRepository: ProposalRepository,
    itineraryRepository: ItineraryRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditTravelAgentState>(AddEditTravelAgentState()) {
    private val addEditTravelAgentViewModel =
        AddEditTravelAgentViewModel(
            travelAgentRepository = travelAgentRepository,
            fileRepository = fileRepository,
            proposalRepository = proposalRepository,
            itineraryRepository = itineraryRepository,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AddEditTravelAgentEvent) {
        addEditTravelAgentViewModel.onEvent(event)
    }
}
